import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../services/Auth/auth.service';
import { RouterLink, RouterModule } from "@angular/router";

export class ContactItems {
    name: string = ''
    title: string = ''
    email: string = ''

    constructor(json: any) {
        this.name = json.name ?? ''
        this.title = json.title ?? ''
        this.email = json.email ?? ''
    }
}

export class Contact {
    title: string = ''
    name: string = ''
    items: ContactItems[] = []
    line: boolean = true

    constructor(json: any) {
        this.title = json.title
        this.name = json.name
        this.items = json.items.map((item: any) => new ContactItems(item))
        this.line = json.line == false ? false : true
    }

}

@Component({
    selector: 'app-contact-page',
    imports: [
        CommonModule,
        RouterModule,
        RouterLink
    ],
    templateUrl: './contact-page.component.html',
    styleUrl: './contact-page.component.scss'
})
export class ContactPageComponent {
    public data: Contact[]

    constructor(
        public authService: AuthService
    ) {
        this.data = [
            new Contact({
                title: 'SALES TEAM',
                name: '<br>Western Division',
                items: [
                    new ContactItems({
                        name: 'Domenic Mangone',
                        title: 'Title:	SVP, Western Division Manager',
                        email: 'dmangone@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Derek Coughlan',
                        title: 'Title:	Vice President, Western Division',
                        email: 'dcoughlan@lionsgate.com'
                    }),
                ]
            }),
            new Contact({
                title: '',
                name: 'Southern Division',
                items: [
                    new ContactItems({
                        name: 'Ana Abrahamian',
                        title: 'Title:	SVP, Southern Division Manager',
                        email: 'aabrahamian@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Jake Bart',
                        title: 'Title:	Sales Manager, Southern Division',
                        email: 'jbart@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Lisa DiMartino',
                        title: 'Title:	Vice President, Sales – Domestic Distribution',
                        email: ' ldimartino@lionsgate.com'
                    }),
                ]
            }),
            new Contact({
                title: '',
                name: 'Central Division',
                items: [
                    new ContactItems({
                        name: 'Sondra Pepke',
                        title: 'Title:	SVP, Central Division Manager',
                        email: 'spepke@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Alayna Peaks',
                        title: 'Title:	Sales Manager, Central Division',
                        email: 'apeaks@lionsgate.com'
                    }),

                ]
            }),
            new Contact({
                title: '',
                name: 'Eastern Division',
                items: [
                    new ContactItems({
                        name: 'Dominic Baltazar',
                        title: 'Title:	SVP, Eastern Division Manager',
                        email: 'dbaltazar@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Jose Herrera',
                        title: 'Title:	Senior Sales Manager, Eastern Division',
                        email: 'jherrera@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Liat Even',
                        title: 'Title:	Sales Manager, Theatrical Distribution',
                        email: 'leven@lionsgate.com'
                    }),
                ]
            }),
            new Contact({
                title: 'FINANCE TEAM',
                name: '',
                items: [
                    new ContactItems({
                        name: 'Debbie Ricks',
                        title: 'Title:	SVP, Theatrical Finance & Administration',
                        email: 'dricks@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Duran McDew',
                        title: 'Title:	Director, Theatrical Finance & Administration',
                        email: 'dmcdew@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'David Magedman',
                        title: 'Title:	Senior Manager, Theatrical Finance',
                        email: 'damagedman@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Joe Briones',
                        title: 'Title:	Coordinator, Theatrical Finance & Administration',
                        email: 'jbriones@lionsgate.com'
                    }),
                ]
            }),
            new Contact({
                title: 'MARKETING TEAM',
                name: '',
                items: [
                    new ContactItems({
                        name: 'Ryan Garcia',
                        title: 'Title:	Senior Director, Exhibitor Marketing',
                        email: 'rgarcia@lionsgate.com'
                    }),
                    new ContactItems({
                        name: 'Clara Madenwald',
                        title: 'Title:	Coordinator, Exhibitor Marketing Embed',
                        email: 'CMadenwald@lionsgate.com'
                    }),
                ]
            }),
            new Contact({
                title: 'WEBSITE SUPPORT',
                name: '',
                line: false,
                items: [
                    new ContactItems({
                        name: 'Lionsgate Repertory',
                        title: '',
                        email: 'support@lionsgaterepertory.com'
                    }),
                ]
            }),
        ]
    }
}
